import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_184f6891-74ff-4ba6-8bec-c6519cbaf0d7/artifacts/bsbwzwf2_4bc73b77-e897-4753-adb6-bb459ed596b6.png";

export const money = (cents) => `$${(cents / 100).toFixed(2)}`;

export default api;
